import { getDisplayNameItemChanges } from "helpers/bid";
import { dateTimeToView } from "helpers/date";
import { bidItemTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import { divIcon } from "leaflet";
import React, { Fragment } from "react";
import { Marker, Tooltip } from "react-leaflet";

const BidItemsChangePoints = React.memo(({ bidItemsChanges }) => {
    const icon = divIcon({ className: "map-icon--item-changes", iconSize: [22, 22] });
    return bidItemsChanges.map((el, index) => <BidItemChangePoint key={index} icon={icon} item={el} />);
});

const BidItemChangePoint = (props) => {
    const {
        item: { itemChanges, location },
        icon,
    } = props;
    if (!location) {
        return null;
    }
    return (
        <Marker position={[...location].reverse()} icon={icon}>
            <Tooltip
                className="map__tooltip-route-marker leaflet-tooltip--left-align leaflet-tooltip--light"
                direction="top"
            >
                <div className="route-icon__time-tooltip">
                    <div className="font-weight-bold">Дата</div>
                    <div>{dateTimeToView(itemChanges[0].startedAt)}</div>
                    <div />
                    {itemChanges.map((itemChange, index) => {
                        const { itemType } = itemChange;
                        return (
                            <Fragment key={index}>
                                <div className="font-weight-bold">{enumLabel(bidItemTypes, itemType)}</div>
                                <div>{getDisplayNameItemChanges(itemChange)}</div>
                                <div />
                            </Fragment>
                        );
                    })}
                </div>
            </Tooltip>
        </Marker>
    );
};

const BidItemsChanges = (props) => <BidItemsChangePoints {...props} />;

export default BidItemsChanges;
